<template>
    <div class="collection">
        <div class="container">
            <div class="top-select">
                <el-select v-model="allOneValue" @change="allOneClick" class="select" placeholder="请选择">
                    <el-option v-for="item in allOne" :key="item.value" :label="item.label"
                        :value="{ value: item.value, label: item.label }">
                    </el-option>
                </el-select>
                <el-select v-model="optionsValue" class="select" placeholder="请选择" @change="handleCompany">
                    <el-option v-for="item in options" :key="item.value" :label="item.label"
                        :value="{ value: item.value, label: item.label }">
                    </el-option>
                </el-select>
                <el-date-picker v-model="timer" type="year" placeholder="选择年" :picker-options="pickerBeginDateBefore"
                    @change="handleTime">
                </el-date-picker>
            </div>
            <!-- 顶部 -->
            <div class="top-cont">
                <dv-border-box-7>
                    <div class="echarts1">
                        <div class="echarts-top-num">
                            <p class="top-icon">回款总额</p>
                            <div class="num-dis">
                                <!-- <div class="box-items" id="TNum"></div> -->
                                <div id="number" class="number"></div>
                            </div>
                        </div>
                        <div class="echarts-top-surface">
                            <div class="width-height" id="width-height">
                                <div id="repayment" :style="{ width: '100%', height: '100%' }"></div>
                            </div>
                        </div>
                    </div>
                </dv-border-box-7>
            </div>
            <!-- 中间 -->
            <div class="middle-cont">
                <div class="middle-block">
                    <dv-border-box-7>
                        <div class="cont-moddle" @mouseover="changIconsBlockPosition('enter', 1)"
                            @mouseleave="changIconsBlockPosition('out')">
                            <div class="cont-bg-div" style="height: 13%">
                                <div class="div-index">
                                    <p class="cont-bg-event">
                                        <span>回款客户地域分布</span>
                                    </p>
                                    <div class="icons-block">
                                        <iconsBlock ref="iconsFir" class="cont-position" :timeArray="timerData" :infoTitle="'回款客户地域分布'"
                                            :idName="'moddleOne'" :stringPaintChart="moddleOneData" @download="download"
                                            @changeTextColor="changeTextColor"
                                            :details="COUNSTDATE.COLLECTION_REGION" />
                                    </div>
                                </div>
                            </div>
                            <div class="width-height" style="height: 87%">
                                <div id="moddleOne" :style="{ width: '100%', height: '100%' }"></div>
                            </div>
                        </div>
                    </dv-border-box-7>
                </div>
                <div class="middle-block" @mouseover="changIconsBlockPosition('enter', 2)"
                    @mouseleave="changIconsBlockPosition('out')">
                    <dv-border-box-7>
                        <div class="cont-moddle">
                            <div class="cont-bg-div" style="height: 16%">
                                <div class="div-index">
                                    <p class="cont-bg-event">回款客户行业分布</p>
                                    <div class="icons-block">
                                        <iconsBlock ref="iconsSec" class="cont-position" :timeArray="timerData" @chooseData="childByValue"
                                            :infoTitle="'回款客户行业分布'" :idName="idName1"
                                            :stringPaintChart="childByValue" @download="download"
                                            @changeTextColor="changeTextColor"
                                            :details="COUNSTDATE.COLLECTION_INDUSTRY" />
                                    </div>
                                </div>
                            </div>
                            <div class="width-height" style="height: 86%">
                                <div id="moddleTwo" :style="{ width: '100%', height: '100%' }"></div>
                            </div>
                        </div>
                    </dv-border-box-7>
                </div>
                <div class="middle-block" @mouseover="changIconsBlockPosition('enter', 3)"
                    @mouseleave="changIconsBlockPosition('out')">
                    <dv-border-box-7>
                        <div class="cont-moddle">
                            <div class="cont-bg-div" id="cont-bg-div">
                                <p class="cont-top-bg">回款客户金额分布</p>
                                <div class="icons-block">
                                    <iconsBlock ref="iconsThr" class="cont-position" :timeArray="timerData" @chooseData="childByValue"
                                        :infoTitle="'回款客户回款金额分布'" :idName="idName2"
                                        :stringPaintChart="childByValue" @download="download"
                                        @changeTextColor="changeTextColor" :details="COUNSTDATE.COLLECTION_MONEY" />
                                </div>
                            </div>
                            <div class="width-height" id="width-height height-bg">
                                <div id="moddleThree" :style="{ width: '100%', height: '90%' }"></div>
                            </div>
                        </div>
                    </dv-border-box-7>
                </div>
                <div class="middle-block" @mouseover="changIconsBlockPosition('enter', 4)"
                    @mouseleave="changIconsBlockPosition('out')">
                    <dv-border-box-7>
                        <div class="cont-moddle">
                            <div class="cont-bg-div div-index" id="cont-bg-div">
                                <div class="cont-top-bg">
                                    <div>客户回款周期</div>
                                </div>
                                <div class="icons-block">
                                    <iconsBlock ref="iconsFou" class="cont-position" :timeArray="timerData" :infoTitle="'客户回款周期'"
                                        @chooseData="childByValue" :idName="idName3"
                                        :stringPaintChart="childByValue" @download="download"
                                        @changeTextColor="changeTextColor" :details="COUNSTDATE.COLLECTION_CYCLE" />
                                </div>
                            </div>
                            <div class="width-height" id="width-height  height-bg">
                                <div id="moddleFour" :style="{ width: '100%', height: '90%' }"></div>
                            </div>
                        </div>
                    </dv-border-box-7>
                </div>
            </div>
            <!-- 底部 -->
            <div class="bottom-cont">
                <dv-border-box-7>
                    <div class="bottom">
                        <div class="bottom-one">
                            <div class="middle-data" style="height: 16%">
                                <p class="cont-bg-event">回款顾问数据分析</p>
                            </div>
                            <div class="middle-right-container width-height">
                                <div class="middle-right-left">
                                    <div class="people-img"></div>
                                    <p class="p-p">
                                        <animate-number from="1" :to="peopleNum" :key="peopleNum" class="p-text">
                                        </animate-number>人
                                    </p>
                                    <p class="p-text-bot">回款顾问数</p>
                                </div>
                            </div>
                        </div>
                        <div class="bottom-two">
                            <div style="height: 16%">
                                <p class="p-font">回款顾问岗位分布</p>
                            </div>
                            <div class="echarts-h">
                                <div class="width-height" id="width-height">
                                    <div id="bottomOne" :style="{ width: '100%', height: '100%' }"></div>
                                </div>
                            </div>
                        </div>
                        <div class="bottom-three">
                            <!-- <div style="height: 16%"> -->
                            <div style="height: 16%">
                                <p class="p-font">回款顾问工龄分布</p>
                            </div>
                            <div class="echarts-h">
                                <div class="width-height" id="width-height">
                                    <div id="bottomTwo" :style="{ width: '100%', height: '100%' }"></div>
                                </div>
                            </div>
                        </div>
                        <div class="bottom-four">
                            <!-- <div style="height: 16%"> -->
                            <div style="height: 16%">
                                <p class="p-font">回款顾问学历分布</p>
                            </div>
                            <!-- </div> -->
                            <div class="echarts-h">
                                <div class="width-height" id="width-height">
                                    <div id="bottomThree" :style="{ width: '100%', height: '100%' }"></div>
                                </div>
                            </div>
                        </div>
                        <div class="bottom-five">
                            <div style="height: 16%">
                                <p class="p-font">回款顾问性别分布</p>
                            </div>
                            <div class="echarts-h">
                                <div class="width-height" id="width-height">
                                    <div id="bottomFour" :style="{ width: '100%', height: '100%' }"></div>
                                </div>
                            </div>
                        </div>
                        <div class="bottom-six">
                            <div style="height: 16%">
                                <p class="p-font">回款顾问婚姻情况</p>
                            </div>
                            <div class="echarts-h">
                                <div class="width-height" id="width-height">
                                    <div id="bottomFive" :style="{ width: '100%', height: '100%' }"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </dv-border-box-7>
            </div>
        </div>
    </div>
</template>

<script>
import {
    GetRegionalClientIncomeAmountGrade,
    GetRegionalMonthIncomeAmount,
    GetRegionalCounselorWorkyear,
    GetRegionalCounselorEducation,
    GetRegionalCounselorGender,
    GetRegionalCounselorMarital,
    GetRegionalCounselorPPerformance,
    GetRegionalClientGradeIncomeCycle,
    GetRegionalClientGradeIncomeCycleByDateRange,
    GetRegionalClientIndustry,
    GetRegionalIncomeAmountLocation,
    GetRegionComboBox,
    GetCompaniesData,
    GetIncomeAmount,
    GetRegionalClientIndustryByDateRange,
    GetRegionalClientIncomeAmountGradeByDateRange,
} from "@/api/api";
import { exportImg } from "../../utils/downLoad.js";
import $ from "jquery";
import { Digit } from "../../assets/js/index.js";
import iconsBlock from "./iconsBlock/index.vue";
import COUNSTDATE from "../../constants/index";

export default {
    components: {
        iconsBlock,
    },
    data() {
        return {
            COUNSTDATE: COUNSTDATE,
            timer: new Date(),
            idName1:"moddleTwo",
            idName2:"moddleThree",
            idName3:"moddleFour",
            urlData: "",
            optionsValue: "",
            allOneValue: "",
            peopleNum: "0",
            countryId: 0,
            dqCountryId: 0,
            companyId: 0,
            allOne: [],
            options: [],
            value: "",
            chartNum: ["0", "0", "0", "0", "0", "0", "0", "0", "0"],
            isChildText: false,
            localData: [],
            total: 0,
            growth: 0,
            timeDefaultShow: "",
            pickerBeginDateBefore: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            timerData: [],
            regionId: 0,
            companyIded: 0,
            curDate:"",
            curTime:"",
        };
    },

    async mounted() {
        this.onClick()
        this.twoClick()
        this.comboBoxData();
        this.etCountDays()

    },

    methods: {

        etCountDays() {
            let curDate = new Date()
            let curMonth = curDate.getMonth()
            curDate.setMonth(curMonth + 1)
            curDate.setDate(0)
            /* 返回当月的天数和月份 */
            this.curDate=curDate.getDate()
            return { day: curDate.getDate(), month: curMonth + 1 }
        },

        childByValue(data, value, countryValue, companyValue) {
            if (data != undefined){
                this.timerData = value
                var arr=value[1].substring(5,7)
            if(arr=="01"){
                this.curTime="-31"
            }else if(arr=="02"){
                this.curTime="-28"
            }else if(arr=="03"){
                this.curTime="-31"
            }else if(arr=="04"){
                this.curTime="-30"
            }else if(arr=="05"){
                this.curTime="-31"
            }else if(arr=="06"){
                this.curTime="-30"
            }else if(arr=="07"){
                this.curTime="-31"
            }else if(arr=="08"){
                this.curTime="-31"
            }else if(arr=="09"){
                this.curTime="-30"
            }else if(arr=="10"){
                this.curTime="-31"
            }else if(arr=="11"){
                this.curTime="-30"
            }else if(arr=="12"){
                this.curTime="-31"
            }
                this.regionId = countryValue
                this.companyIded = companyValue.value
            }
            if (data == undefined) {
                // if(this.idName1!=""){
                //     this.moddleTwoDataTWo();
                // }
                // if(this.idName2!=""){
                //     this.moddleThreeDataTwo();
                // }
                // if(this.idName2!=""){
                //     this.moddleFourDataTwo();
                // }

                console.log('[ 123 ] >', 123)
            } else if (data == "moddleTwo") {
                this.moddleTwoDataTWo();
            } else if (data == "moddleThree") {
                this.moddleThreeDataTwo();
            } else if (data == "moddleFour") {
                this.moddleFourDataTwo();
            }
        },

        //本季度开始
        onClick(picker) {
            var now = new Date(); // 当前日期
            var nowMonth = now.getMonth(); // 当前月
            var nowYear = now.getYear(); // 当前年
            nowYear += (nowYear < 2000) ? 1900 : 0;
            let m = 0;
            if (nowMonth < 3) {//012
                m = 0
            } else if (2 < nowMonth && nowMonth < 6) {//345
                m = 3
            } else if (5 < nowMonth && nowMonth < 8) {//678
                m = 6
            } else if (nowMonth > 8) { //9 10 11
                m = 9
            }
            let quarterStart = new Date(nowYear, m, 1)

            this.formatDate(quarterStart)
        },
        //本季度结束
        twoClick(picker) {
            var now = new Date(); // 当前日期
            var nowMonth = now.getMonth(); // 当前月
            var nowYear = now.getYear(); // 当前年
            nowYear += (nowYear < 2000) ? 1900 : 0;
            let i = 0;
            if (nowMonth < 3) {//012
                i = 3
            } else if (2 < nowMonth && nowMonth < 6) {//345
                i = 6
            } else if (5 < nowMonth && nowMonth < 8) {//678
                i = 9
            } else if (nowMonth > 8) { //9 10 11
                i = 0
            }

            let quarterEnd = new Date(nowYear, i, 1).getTime() - (60 * 60 * 24 * 1000)
            let aa = Date(parseInt(quarterEnd) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ')
            this.formatDate(new Date(aa))
        },

        formatDate(date) {
            var myyear = date.getFullYear();
            var mymonth = date.getMonth() + 1;
            var myweekday = date.getDate();
            if (mymonth < 10) {
                mymonth = "0" + mymonth;
            }
            if (myweekday < 10) {
                myweekday = "0" + myweekday;
            }
            this.timerData.push(myyear + "-" + mymonth)
            return (myyear + "-" + mymonth);
        },


        
        chartDate() {
            this.repaymentNum();
            this.moddleTwoData();
            this.moddleThreeData();
            this.moddleFourData();
            this.bottomOneData();
            this.bottomTwoData();
            this.bottomThreeData();
            this.bottomFourData();
            this.bottomFiveData();
            this.moddleOneData();
            this.getIncomeAmount();
        },

        handleTime() {
            this.total = "";
            this.numData();
            this.chartDate();
        },
        handleCompany(v) {
            this.companyId = v.value;
            this.chartDate();
            this.numData();
        },
        allOneClick(v) {
            this.countryId = v.value;
            this.options = [];
            this.optionsValue = "";
            this.GetCompaniesData();
            //   this.chartDate();
        },
        //回款总额
        getIncomeAmount() {
            this.total = 0;
            let param = {
                year: this.getYear,
                regionid: this.countryId,
                companyid: this.companyId,
                ticket: this.urlData,
            };
            GetIncomeAmount(param).then((res) => {
                let { IncomeAmount, YearOnYearGrowth } = res.Data;
                this.total = IncomeAmount.toFixed(2);
                this.growth = YearOnYearGrowth.toFixed(2);
                this.numData();
            });
        },
        numData() {
            $("#number").html("");
            let dom = document.getElementById("number");
            let digit = new Digit({
                number: this.total, // 到达指定数值停止滚动
                finish: 2, // 整体完成时间
                speed: 1, // 数值越大，越多数字同时进行翻滚，取值范围（1 ~ 10）
                direction: "right", // 动画方向
                dom: dom, // 在指定dom节点插入动画
            });
            digit.render();
        },

        // 获取全国大区
        comboBoxData() {
            GetRegionComboBox({ ticket: this.urlData }).then((res) => {
                this.allOneValue = res.Data[0].RegionName;
                if (res.Data.length >= 0) {
                    this.countryId = res.Data[0].Id;
                }

                res.Data.forEach((e) => {
                    const item = {
                        value: e.Id,
                        label: e.RegionName,
                    };
                    this.allOne.push(item);
                    //   this.chartDate();
                });
                this.GetCompaniesData();
            });
        },

        // 获取公司
        GetCompaniesData() {
            let param = {
                regionId: this.countryId,
                ticket: this.urlData,
            };
            GetCompaniesData(param).then((res) => {
                this.optionsValue = res[0].Text;
                this.companyId = res[0].CompanyId;

                // debugger
                res.forEach((e) => {
                    const item = {
                        value: e.CompanyId,
                        label: e.Text,
                    };
                    this.options.push(item);
                });
                this.chartDate();
            });
        },

        toOrderNum(num) {
            var newnum = num.toString(); // 数字变成字符串
            if (newnum.length) {
                const zeroStr = "000000000";
                newnum = (zeroStr + newnum).slice(-9);
                this.chartNum = newnum.split("");
            } else {
                this.$message({
                    showClose: true,
                    message: "显示异常",
                    type: "warning",
                });
            }
        },
        setNumberTransform() {
            var numberItems = $(".item");
            const numberArr = this.chartNum.filter((item) => !isNaN(item));
            for (var index = 0; index < numberItems.length; index++) {
                const elem = numberItems[index];
                elem.style.transform =
                    "translate(-50%, -" + numberArr[index] * 10 + "%)";
            }
        },

        //   回款总额
        repaymentNum() {
            let param = {
                year: this.getYear,
                regionId: this.countryId,
                companyId: this.companyId,
                ticket: this.urlData,
            };
            GetRegionalMonthIncomeAmount(param).then((res) => {
                if (res.Status === 1) {
                    var monthData = [];
                    var incomeAmountData = [];
                    for (var i = 0; i < res.Data.length; i++) {
                        monthData.push(res.Data[i].Month + "月");
                        incomeAmountData.push(
                            (res.Data[i].IncomeAmount / 10000).toFixed(2)
                        );
                    }
                    let repayment = this.$echarts.init(
                        document.getElementById("repayment")
                    );
                    repayment.setOption({
                        xAxis: {
                            type: "category",
                            data: monthData,
                            axisLabel: {
                                show: true,
                                textStyle: {
                                    color: "#fff", //这里用参数代替了
                                },
                            },
                        },
                        yAxis: {
                            type: "value",
                            axisLabel: {
                                show: true,
                                textStyle: {
                                    color: "#fff", //这里用参数代替了
                                },
                            },
                            splitLine: {
                                show: true,
                                lineStyle: {
                                    color: ["#404666"],
                                    width: 1,
                                    type: "solid",
                                },
                            },
                        },

                        grid: {
                            right: "2%",
                            bottom: "0%",
                            left: "2%",
                            top: "6%",
                            containLabel: true,
                        },

                        tooltip: {
                            trigger: "axis",
                            formatter: "回款金额(万): {c}",
                            axisPointer: {
                                type: "cross",
                                label: {
                                    backgroundColor: "#6a7985",
                                },
                            },
                        },
                        series: [
                            {
                                data: incomeAmountData,
                                type: "bar",
                                color: "#1C82FF",
                                barWidth: 23,
                            },
                        ],
                    });
                } else {
                    window.location.href = "http://staff.risfond.com/signin.aspx";
                }
            });
        },

        // 回款客户地域分布
        moddleOneData(pName, Chinese_) {
            // 基于准备好的dom，初始化echarts实例
            var myChartContainer = document.getElementById("moddleOne");
            var myChartChina = this.$echarts.init(myChartContainer);
            let param = {
                year: this.getYear,
                regionId: this.countryId,
                companyId: this.companyId,
                ticket: this.urlData,
            };
            var list = [];
            GetRegionalIncomeAmountLocation(param).then((res) => {
                let Data = [
                    "北京市",
                    "天津市",
                    "上海市",
                    "重庆市",
                    "河北省",
                    "河南省",
                    "云南省",
                    "辽宁省",
                    "黑龙江省",
                    "湖南省",
                    "安徽省",
                    "山东省",
                    "新疆维吾尔自治区",
                    "江苏省",
                    "浙江省",
                    "江西省",
                    "湖北省",
                    "广西壮族自治区",
                    "甘肃省",
                    "山西省",
                    "内蒙古自治区",
                    "陕西省",
                    "吉林省",
                    "福建省",
                    "贵州省",
                    "广东省",
                    "青海省",
                    "西藏自治区",
                    "四川省",
                    "宁夏回族自治区",
                    "海南省",
                    "台湾省",
                    "香港特别行政区",
                    "澳门特别行政区",
                ];
                var lastData = 0;
                var numData = 2;
                if (res.Data.length === 0) {
                    numData;
                } else {
                    numData = res.Data[0].ClientCount;
                    lastData = res.Data.pop().ClientCount;
                }
                res.Data.forEach((e) => {
                    var index1 = Data.indexOf(e.LocationName);
                    if (index1 >= 0) {
                        let name = Data[index1];
                        Data.splice(index1, 1);
                        var item = {
                            name: name,
                            value: e.ClientCount,
                        };
                        list.push(item);
                    }
                });
                for (var i = 0; i < Data.length; i++) {
                    let item = {
                        name: Data[i],
                        value: 0,
                    };
                    list.push(item);
                }

                var optionMap = {
                    tooltip: {},
                    legend: {
                        orient: "vertical",
                        left: "left",
                        data: [""],
                    },
                    visualMap: {
                        min: lastData,
                        max: numData,
                        left: "0%",
                        itemWidth: 10,
                        itemHeight: 90,
                        bottom: "bottom",
                        calculable: false,
                        color: ["#547CCE", "#A2CCF8"],
                    },

                    selectedMode: "single",
                    series: [
                        {
                            name: "",
                            type: "map",
                            roam: true,
                            zoom: 2.0,
                            top: "30%",
                            bottom: "19%",
                            mapType: "china",
                            itemStyle: {
                                color: "transparent",
                                normal: {
                                    borderColor: "rgba(0, 0, 0, 0.2)",
                                },
                            },
                            showLegendSymbol: false,
                            label: {
                                normal: {
                                    show: false,
                                },
                                emphasis: {
                                    show: false,
                                },
                            },
                            data: list,
                        },
                    ],
                };

                myChartChina.setOption(optionMap);
                window.onresize = function () {
                    //   resizeMyChartContainer();
                    myChartChina.resize();
                };
            });
        },
        moddleTwoDataT() {
            this.moddleTwoData();
        },

        moddleTwoDataTWo() {
            let params = {
                regionId: this.regionId,
                companyId: this.companyIded,
                DateFrom: this.timerData[0] + "-01",
                DateTo: this.timerData[1] +this.curTime,
                ticket: this.urlData,
            };
            GetRegionalClientIndustryByDateRange(params).then((res) => {
                var arrData = [];
                var arrName = [];
                res.Data.forEach((e) => {
                    const item = {
                        value: e.ClientCount,
                        name: e.Text,
                    };
                    arrName.push(e.Text);
                    arrData.push(item);
                });

                let moddleTwo = this.$echarts.init(
                    document.getElementById("moddleTwo")
                );
                moddleTwo.setOption({
                    tooltip: {
                        trigger: "item",
                        formatter: "{b}: {d}%",
                    },
                    legend: {
                        show: false,
                        orient: "horizontal",
                        borderWidth: 0,
                        icon: "rect",
                        pageIconColor: "#1C82FF",
                        pageTextStyle: {
                            color: "#fff", //翻页数字颜色
                        },
                        orient: "vertical",
                        bottom: "bottom",
                        type: "scroll",
                        width: 350,
                        itemGap: 20,
                        itemWidth: 10,
                        itemHeight: 10,
                        data: arrName,
                    },
                    series: [
                        {
                            name: "",
                            type: "pie",
                            radius: "60%",
                            top: "10%",
                            bottom: "2%",
                            data: arrData,
                            hoverAnimation: false,
                            label: {
                                normal: {
                                    show: true,
                                    fontSize: "12",
                                    borderWidth: 0,
                                    color: this.isTextColor,
                                },
                            },
                        },
                    ],
                });
            });
        },

        // 回款客户行业分布
        moddleTwoData() {
            let param = {
                year: this.getYear,
                regionId: this.countryId,
                companyId: this.companyId,
                ticket: this.urlData,
            };
            GetRegionalClientIndustry(param).then((res) => {
                var arrData = [];
                var arrName = [];
                res.Data.forEach((e) => {
                    const item = {
                        value: e.ClientCount,
                        name: e.Text,
                    };
                    arrName.push(e.Text);
                    arrData.push(item);
                });

                let moddleTwo = this.$echarts.init(
                    document.getElementById("moddleTwo")
                );
                moddleTwo.setOption({
                    tooltip: {
                        trigger: "item",
                        formatter: "{b}: {d}%",
                    },
                    legend: {
                        show: false,
                        orient: "horizontal",
                        borderWidth: 0,
                        icon: "rect",
                        pageIconColor: "#1C82FF",
                        pageTextStyle: {
                            color: "#fff", //翻页数字颜色
                        },
                        orient: "vertical",
                        bottom: "bottom",
                        type: "scroll",
                        width: 350,
                        itemGap: 20,
                        itemWidth: 10,
                        itemHeight: 10,
                        data: arrName,
                    },
                    series: [
                        {
                            name: "",
                            type: "pie",
                            radius: "60%",
                            top: "10%",
                            bottom: "2%",
                            data: arrData,
                            hoverAnimation: false,
                            label: {
                                normal: {
                                    show: true,
                                    fontSize: "12",
                                    borderWidth: 0,
                                    color: this.isTextColor,
                                },
                            },
                        },
                    ],
                });
            });
        },

        moddleThreeDataTwo() {
            let param = {
                regionId: this.regionId,
                companyId: this.companyIded,
                DateFrom: this.timerData[0] + "-01",
                DateTo: this.timerData[1] +this.curTime,
                ticket: this.urlData,
            };
            GetRegionalClientIncomeAmountGradeByDateRange(param).then((res) => {
                var arrNum = [];
                res.Data.forEach((e) => {
                    arrNum.push(e.ClientCount);
                });
                let moddleThree = this.$echarts.init(
                    document.getElementById("moddleThree")
                );
                var xdata = [
                    "10万以下",
                    "10-20万",
                    "20-40万",
                    "40-60万",
                    "60-100万",
                    "100万以上",
                ];
                moddleThree.setOption({
                    legend: {
                        // 对应series的name
                        type: "scroll",
                        pageIconColor: "#1C82FF",
                        bottom: "1%",
                        pageTextStyle: {
                            color: this.isTextColor, //翻页数字颜色
                        }, //翻页数字设置
                        x: "center",
                        y: "bottom",
                        itemWidth: 10,
                        itemHeight: 10,
                        textStyle: {
                            //图例文字的样式
                            color: this.isTextColor,
                            fontSize: 10,
                        },
                        data: xdata,
                    },
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "15%",
                        top: "13%",
                        containLabel: true,
                    },
                    tooltip: {
                        //trigger: 'axis',    //显示其他分类
                        axisPointer: {
                            // 坐标轴指示器，坐标轴触发有效
                            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                        },
                    },
                    yAxis: [
                        {
                            type: "category",
                            axisLabel: {
                                interval: 0,
                                rotate: 25,
                                color: this.isTextColor,
                                textStyle: {
                                    fontSize: "8px",
                                },
                            },
                            axisLine: {
                                lineStyle: {
                                    type: "solid",
                                    color: "#404666", //左边线的颜色
                                    width: "2", //坐标线的宽度
                                },
                            },
                            data: [
                                "10万以下",
                                "10-20万",
                                "20-40万",
                                "40-60万",
                                "60-100万",
                                "100万以上",
                            ],
                        },
                    ],
                    xAxis: [
                        {
                            type: "value",
                            axisLine: {
                                lineStyle: {
                                    type: "solid",
                                    color: "#000",
                                    width: "2",
                                },
                            },
                            splitLine: {
                                show: true,
                                lineStyle: {
                                    color: "#404666",
                                },
                            },
                            axisLabel: {
                                textStyle: {
                                    color: this.isTextColor,
                                },
                            },
                        },
                    ],
                    series: [
                        {
                            name: "10万以下",
                            type: "bar",
                            stack: "广告",
                            barWidth: "10",
                            data: [arrNum[5]],
                            itemStyle: {
                                //配置样式，设置每个柱子的颜色
                                normal: {
                                    color: function (params) {
                                        var colorList = ["#1C82FF"];
                                        return colorList[params.dataIndex];
                                    },
                                },
                            },
                        },
                        {
                            name: "10-20万",
                            type: "bar",
                            barWidth: "10",
                            stack: "广告",
                            data: [0, arrNum[4]],
                            itemStyle: {
                                //配置样式，设置每个柱子的颜色
                                normal: {
                                    color: function (params) {
                                        var colorList = ["#1C82FF", "#1FFD8A"];
                                        return colorList[params.dataIndex];
                                    },
                                },
                            },
                        },
                        {
                            name: "20-40万",
                            type: "bar",
                            barWidth: "10",
                            stack: "广告",
                            data: [0, 0, arrNum[3]],
                            itemStyle: {
                                //配置样式，设置每个柱子的颜色
                                normal: {
                                    color: function (params) {
                                        var colorList = ["#1C82FF", "#1FFD8A", "#F8D135"];
                                        return colorList[params.dataIndex];
                                    },
                                },
                            },
                        },
                        {
                            name: "40-60万",
                            type: "bar",
                            barWidth: "10",
                            stack: "广告",
                            data: [0, 0, 0, arrNum[2]],
                            itemStyle: {
                                //配置样式，设置每个柱子的颜色
                                normal: {
                                    color: function (params) {
                                        var colorList = [
                                            "#1C82FF",
                                            "#1FFD8A",
                                            "#F8D135",
                                            "#FF7979",
                                        ];
                                        return colorList[params.dataIndex];
                                    },
                                },
                            },
                        },
                        {
                            name: "60-100万",
                            type: "bar",
                            barWidth: "10",
                            stack: "广告",
                            data: [0, 0, 0, 0, arrNum[1]],
                            itemStyle: {
                                //配置样式，设置每个柱子的颜色
                                normal: {
                                    color: function (params) {
                                        var colorList = [
                                            "#1C82FF",
                                            "#1FFD8A",
                                            "#F8D135",
                                            "#FF7979",
                                            "#9CFFE8",
                                        ];
                                        return colorList[params.dataIndex];
                                    },
                                },
                            },
                        },
                        {
                            name: "100万以上",
                            type: "bar",
                            barWidth: "10",
                            stack: "广告",
                            data: [0, 0, 0, 0, 0, arrNum[0]],
                            itemStyle: {
                                //配置样式，设置每个柱子的颜色
                                normal: {
                                    color: function (params) {
                                        var colorList = [
                                            "#1C82FF",
                                            "#1FFD8A",
                                            "#F8D135",
                                            "#FF7979",
                                            "#9CFFE8",
                                            "#8E5FFF",
                                        ];
                                        return colorList[params.dataIndex];
                                    },
                                },
                            },
                        },
                    ],
                });
            });
        },

        // 回款客户回款金额分布
        moddleThreeData() {
            let param = {
                year: this.getYear,
                regionId: this.countryId,
                companyId: this.companyId,
                ticket: this.urlData,
            };
            GetRegionalClientIncomeAmountGrade(param).then((res) => {
                var arrNum = [];
                res.Data.forEach((e) => {
                    arrNum.push(e.ClientCount);
                });
                let moddleThree = this.$echarts.init(
                    document.getElementById("moddleThree")
                );
                var xdata = [
                    "10万以下",
                    "10-20万",
                    "20-40万",
                    "40-60万",
                    "60-100万",
                    "100万以上",
                ];
                moddleThree.setOption({
                    legend: {
                        // 对应series的name
                        type: "scroll",
                        pageIconColor: "#1C82FF",
                        bottom: "1%",
                        pageTextStyle: {
                            color: this.isTextColor, //翻页数字颜色
                        }, //翻页数字设置
                        x: "center",
                        y: "bottom",
                        itemWidth: 10,
                        itemHeight: 10,
                        textStyle: {
                            //图例文字的样式
                            color: this.isTextColor,
                            fontSize: 10,
                        },
                        data: xdata,
                    },
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "15%",
                        top: "13%",
                        containLabel: true,
                    },
                    tooltip: {
                        //trigger: 'axis',    //显示其他分类
                        axisPointer: {
                            // 坐标轴指示器，坐标轴触发有效
                            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                        },
                    },
                    yAxis: [
                        {
                            type: "category",
                            axisLabel: {
                                interval: 0,
                                rotate: 25,
                                color: this.isTextColor,
                                textStyle: {
                                    fontSize: "8px",
                                },
                            },
                            axisLine: {
                                lineStyle: {
                                    type: "solid",
                                    color: "#404666", //左边线的颜色
                                    width: "2", //坐标线的宽度
                                },
                            },
                            data: [
                                "10万以下",
                                "10-20万",
                                "20-40万",
                                "40-60万",
                                "60-100万",
                                "100万以上",
                            ],
                        },
                    ],
                    xAxis: [
                        {
                            type: "value",
                            axisLine: {
                                lineStyle: {
                                    type: "solid",
                                    color: "#000",
                                    width: "2",
                                },
                            },
                            splitLine: {
                                show: true,
                                lineStyle: {
                                    color: "#404666",
                                },
                            },
                            axisLabel: {
                                textStyle: {
                                    color: this.isTextColor,
                                },
                            },
                        },
                    ],
                    series: [
                        {
                            name: "10万以下",
                            type: "bar",
                            stack: "广告",
                            barWidth: "10",
                            data: [arrNum[5]],
                            itemStyle: {
                                //配置样式，设置每个柱子的颜色
                                normal: {
                                    color: function (params) {
                                        var colorList = ["#1C82FF"];
                                        return colorList[params.dataIndex];
                                    },
                                },
                            },
                        },
                        {
                            name: "10-20万",
                            type: "bar",
                            barWidth: "10",
                            stack: "广告",
                            data: [0, arrNum[4]],
                            itemStyle: {
                                //配置样式，设置每个柱子的颜色
                                normal: {
                                    color: function (params) {
                                        var colorList = ["#1C82FF", "#1FFD8A"];
                                        return colorList[params.dataIndex];
                                    },
                                },
                            },
                        },
                        {
                            name: "20-40万",
                            type: "bar",
                            barWidth: "10",
                            stack: "广告",
                            data: [0, 0, arrNum[3]],
                            itemStyle: {
                                //配置样式，设置每个柱子的颜色
                                normal: {
                                    color: function (params) {
                                        var colorList = ["#1C82FF", "#1FFD8A", "#F8D135"];
                                        return colorList[params.dataIndex];
                                    },
                                },
                            },
                        },
                        {
                            name: "40-60万",
                            type: "bar",
                            barWidth: "10",
                            stack: "广告",
                            data: [0, 0, 0, arrNum[2]],
                            itemStyle: {
                                //配置样式，设置每个柱子的颜色
                                normal: {
                                    color: function (params) {
                                        var colorList = [
                                            "#1C82FF",
                                            "#1FFD8A",
                                            "#F8D135",
                                            "#FF7979",
                                        ];
                                        return colorList[params.dataIndex];
                                    },
                                },
                            },
                        },
                        {
                            name: "60-100万",
                            type: "bar",
                            barWidth: "10",
                            stack: "广告",
                            data: [0, 0, 0, 0, arrNum[1]],
                            itemStyle: {
                                //配置样式，设置每个柱子的颜色
                                normal: {
                                    color: function (params) {
                                        var colorList = [
                                            "#1C82FF",
                                            "#1FFD8A",
                                            "#F8D135",
                                            "#FF7979",
                                            "#9CFFE8",
                                        ];
                                        return colorList[params.dataIndex];
                                    },
                                },
                            },
                        },
                        {
                            name: "100万以上",
                            type: "bar",
                            barWidth: "10",
                            stack: "广告",
                            data: [0, 0, 0, 0, 0, arrNum[0]],
                            itemStyle: {
                                //配置样式，设置每个柱子的颜色
                                normal: {
                                    color: function (params) {
                                        var colorList = [
                                            "#1C82FF",
                                            "#1FFD8A",
                                            "#F8D135",
                                            "#FF7979",
                                            "#9CFFE8",
                                            "#8E5FFF",
                                        ];
                                        return colorList[params.dataIndex];
                                    },
                                },
                            },
                        },
                    ],
                });
            });
        },

        // 客户回款周期
        moddleFourDataTwo() {
            let param = {
                regionId: this.regionId,
                companyId: this.companyIded,
                DateFrom: this.timerData[0] + "-01",
                DateTo: this.timerData[1] +this.curTime,
                ticket: this.urlData,
                isIncomeAmount: 1,
            };

            GetRegionalClientGradeIncomeCycleByDateRange(param).then((res) => {
                var arr = [];
                var arrNum = [];
                res.Data.forEach((e) => {
                    arr.push(e.ClientGrade);
                    arrNum.push(e.IncomeAmountCycle);
                });

                let moddleFour = this.$echarts.init(
                    document.getElementById("moddleFour")
                );
                moddleFour.setOption({
                    legend: {
                        // 对应series的name
                        show: false,
                        type: "scroll",
                        pageIconColor: "#1C82FF",
                        pageTextStyle: {
                            color: this.isTextColor, //翻页数字颜色
                        }, //翻页数字设置
                        x: "center",
                        y: "bottom",
                        textStyle: {
                            //图例文字的样式
                            color: this.isTextColor,
                            fontSize: 12,
                        },
                        data: ["V0", "V1-V2", "V3-V4", "V5"],
                    },
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "2%",
                        top: "8%",
                        containLabel: true,
                    },
                    tooltip: {
                        //trigger: 'axis',    //显示其他分类
                        formatter: "回款周期: {c}天",
                        axisPointer: {
                            // 坐标轴指示器，坐标轴触发有效
                            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                        },
                    },
                    xAxis: [
                        {
                            type: "category",
                            axisLabel: {
                                interval: 0,
                                color: this.isTextColor,
                                textStyle: {
                                    fontSize: "10px",
                                },
                            },
                            axisLine: {
                                lineStyle: {
                                    type: "solid",
                                    color: "#404666", //左边线的颜色
                                    width: "2", //坐标线的宽度
                                },
                            },
                            data: ["V0", "V1-V2", "V3-V4", "V5"],
                        },
                    ],
                    yAxis: [
                        {
                            type: "value",
                            axisLine: {
                                lineStyle: {
                                    type: "solid",
                                    color: "#000",
                                    width: "2",
                                },
                            },
                            splitLine: {
                                show: true,
                                lineStyle: {
                                    color: "#404666",
                                },
                            },
                            axisLabel: {
                                textStyle: {
                                    color: this.isTextColor,
                                },
                            },
                        },
                    ],
                    series: [
                        {
                            name: "V0",
                            barWidth: 25,
                            type: "bar",
                            stack: "广告",
                            data: [arrNum[0]],
                            itemStyle: {
                                //配置样式，设置每个柱子的颜色
                                normal: {
                                    color: function (params) {
                                        var colorList = ["#1C82FF"];
                                        return colorList[params.dataIndex];
                                    },
                                },
                            },
                        },
                        {
                            name: "V1-V2",
                            barWidth: 35,
                            type: "bar",
                            stack: "广告",
                            data: [0, arrNum[1]],
                            itemStyle: {
                                //配置样式，设置每个柱子的颜色
                                normal: {
                                    color: function (params) {
                                        var colorList = ["#1C82FF", "#1FFD8A"];
                                        return colorList[params.dataIndex];
                                    },
                                },
                            },
                        },
                        {
                            name: "V3-V4",
                            barWidth: 35,
                            type: "bar",
                            stack: "广告",
                            data: [0, 0, arrNum[2]],
                            itemStyle: {
                                //配置样式，设置每个柱子的颜色
                                normal: {
                                    color: function (params) {
                                        var colorList = ["#1C82FF", "#1FFD8A", "#F8D135"];
                                        return colorList[params.dataIndex];
                                    },
                                },
                            },
                        },
                        {
                            name: "V5",
                            barWidth: 35,
                            type: "bar",
                            stack: "广告",
                            data: [0, 0, 0, arrNum[3]],
                            itemStyle: {
                                //配置样式，设置每个柱子的颜色
                                normal: {
                                    color: function (params) {
                                        var colorList = [
                                            "#1C82FF",
                                            "#1FFD8A",
                                            "#F8D135",
                                            "#FF7979",
                                        ];
                                        return colorList[params.dataIndex];
                                    },
                                },
                            },
                        },
                    ],
                });
            });




        },
        moddleFourData() {
            let param = {
                year: this.getYear,
                regionId: this.countryId,
                companyId: this.companyId,
                ticket: this.urlData,
                isIncomeAmount: 1,
            };
            GetRegionalClientGradeIncomeCycle(param).then((res) => {
                var arr = [];
                var arrNum = [];
                res.Data.forEach((e) => {
                    arr.push(e.ClientGrade);
                    arrNum.push(e.IncomeAmountCycle);
                });

                let moddleFour = this.$echarts.init(
                    document.getElementById("moddleFour")
                );
                moddleFour.setOption({
                    legend: {
                        // 对应series的name
                        show: false,
                        type: "scroll",
                        pageIconColor: "#1C82FF",
                        pageTextStyle: {
                            color: this.isTextColor, //翻页数字颜色
                        }, //翻页数字设置
                        x: "center",
                        y: "bottom",
                        textStyle: {
                            //图例文字的样式
                            color: this.isTextColor,
                            fontSize: 12,
                        },
                        data: ["V0", "V1-V2", "V3-V4", "V5"],
                    },
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "2%",
                        top: "8%",
                        containLabel: true,
                    },
                    tooltip: {
                        //trigger: 'axis',    //显示其他分类
                        formatter: "回款周期: {c}天",
                        axisPointer: {
                            // 坐标轴指示器，坐标轴触发有效
                            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                        },
                    },
                    xAxis: [
                        {
                            type: "category",
                            axisLabel: {
                                interval: 0,
                                color: this.isTextColor,
                                textStyle: {
                                    fontSize: "10px",
                                },
                            },
                            axisLine: {
                                lineStyle: {
                                    type: "solid",
                                    color: "#404666", //左边线的颜色
                                    width: "2", //坐标线的宽度
                                },
                            },
                            data: ["V0", "V1-V2", "V3-V4", "V5"],
                        },
                    ],
                    yAxis: [
                        {
                            type: "value",
                            axisLine: {
                                lineStyle: {
                                    type: "solid",
                                    color: "#000",
                                    width: "2",
                                },
                            },
                            splitLine: {
                                show: true,
                                lineStyle: {
                                    color: "#404666",
                                },
                            },
                            axisLabel: {
                                textStyle: {
                                    color: this.isTextColor,
                                },
                            },
                        },
                    ],
                    series: [
                        {
                            name: "V0",
                            barWidth: 25,
                            type: "bar",
                            stack: "广告",
                            data: [arrNum[0]],
                            itemStyle: {
                                //配置样式，设置每个柱子的颜色
                                normal: {
                                    color: function (params) {
                                        var colorList = ["#1C82FF"];
                                        return colorList[params.dataIndex];
                                    },
                                },
                            },
                        },
                        {
                            name: "V1-V2",
                            barWidth: 35,
                            type: "bar",
                            stack: "广告",
                            data: [0, arrNum[1]],
                            itemStyle: {
                                //配置样式，设置每个柱子的颜色
                                normal: {
                                    color: function (params) {
                                        var colorList = ["#1C82FF", "#1FFD8A"];
                                        return colorList[params.dataIndex];
                                    },
                                },
                            },
                        },
                        {
                            name: "V3-V4",
                            barWidth: 35,
                            type: "bar",
                            stack: "广告",
                            data: [0, 0, arrNum[2]],
                            itemStyle: {
                                //配置样式，设置每个柱子的颜色
                                normal: {
                                    color: function (params) {
                                        var colorList = ["#1C82FF", "#1FFD8A", "#F8D135"];
                                        return colorList[params.dataIndex];
                                    },
                                },
                            },
                        },
                        {
                            name: "V5",
                            barWidth: 35,
                            type: "bar",
                            stack: "广告",
                            data: [0, 0, 0, arrNum[3]],
                            itemStyle: {
                                //配置样式，设置每个柱子的颜色
                                normal: {
                                    color: function (params) {
                                        var colorList = [
                                            "#1C82FF",
                                            "#1FFD8A",
                                            "#F8D135",
                                            "#FF7979",
                                        ];
                                        return colorList[params.dataIndex];
                                    },
                                },
                            },
                        },
                    ],
                });
            });
        },

        // 回款顾问岗位分布
        bottomOneData() {
            let param = {
                year: this.getYear,
                regionId: this.countryId,
                companyId: this.companyId,
                isIncomeAmount: 1,
                ticket: this.urlData,
            };
            GetRegionalCounselorPPerformance(param).then((res) => {
                var arr = [];
                res.Data.forEach((e) => {
                    const item = {
                        product: e.Position,
                        "人数（个）": e.StaffCount,
                        "回款（万）": (e.IncomeAmount / 10000).toFixed(2),
                        // "（万）": (e.PerformanceAmount / 10000).toFixed(2),
                    };
                    arr.push(item);
                });

                let bottomOne = this.$echarts.init(
                    document.getElementById("bottomOne")
                );
                bottomOne.setOption({
                    legend: {
                        bottom: "2%",
                        itemWidth: 12,
                        itemHeight: 12,
                        textStyle: {
                            //图例文字的样式
                            color: "#fff",
                            fontSize: 8,
                        },
                    },
                    grid: {
                        top: "8%",
                        left: "2%",
                        right: "2%",
                        bottom: "12%",
                        containLabel: true,
                    },
                    tooltip: {},
                    dataset: {
                        dimensions: ["product", "人数（个）", "回款（万）"],
                        source: arr,
                    },
                    xAxis: {
                        type: "category",
                        axisLabel: {
                            interval: 0,
                            rotate: 25,
                            color: "#fff",
                            textStyle: {
                                fontSize: "8px",
                            },
                        },

                        axisLine: {
                            lineStyle: {
                                type: "solid",
                                color: "#404666", //左边线的颜色
                                width: "2", //坐标线的宽度
                            },
                        },
                    },
                    yAxis: {
                        type: "value",
                        axisLabel: {
                            color: "#fff",
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: "#404666",
                            },
                        },
                        axisLine: {
                            lineStyle: {
                                type: "solid",
                                color: "#404666", //左边线的颜色
                                width: "2", //坐标线的宽度
                            },
                        },
                    },
                    series: [
                        {
                            type: "bar",
                            barWidth: "23",
                            itemStyle: {
                                //配置样式，设置每个柱子的颜色
                                normal: {
                                    color: function (params) {
                                        var colorList = ["#1C82FF"];
                                        return colorList[0];
                                    },
                                },
                            },
                        },
                        {
                            type: "bar",
                            barWidth: "23",
                            itemStyle: {
                                //配置样式，设置每个柱子的颜色
                                normal: {
                                    color: function (params) {
                                        var colorList = ["#1FFD8A"];
                                        return colorList[0];
                                    },
                                },
                            },
                        },
                        {
                            normal: {
                                padding: [20, 0, 0, 0],
                            },
                        },
                    ],
                });
            });
        },

        // 回款顾问工龄分布
        bottomTwoData() {
            let param = {
                year: this.getYear,
                regionId: this.countryId,
                companyId: this.companyId,
                isIncomeAmount: 1,
                ticket: this.urlData,
            };
            GetRegionalCounselorWorkyear(param).then((res) => {
                var arr = [];
                res.Data.forEach((e) => {
                    const item = {
                        name: e.WorkYear + "年",
                        value: e.StaffCount,
                    };
                    arr.push(item);
                });

                let bottomTwo = this.$echarts.init(
                    document.getElementById("bottomTwo")
                );

                let color = [
                    "#1C82FF",
                    "#1FFD8A",
                    "#8E5FFF",
                    "#9CFFE8",
                    "#FFB377",
                    "#FF6969",
                    "#F8D135",
                ];
                let echartData = arr;

                let formatNumber = function (num) {
                    let reg = /(?=(\B)(\d{3})+$)/g;
                    return num.toString().replace(reg, ",");
                };
                bottomTwo.setOption({
                    color: color,
                    tooltip: {
                        trigger: "item",
                        formatter: "{b}: {d}%",
                    },
                    grid: {
                        top: "8%",
                        left: "2%",
                        right: "2%",
                        bottom: "8%",
                        containLabel: true,
                    },
                    legend: {
                        type: "scroll",
                        pageIconColor: "#1C82FF",
                        pageTextStyle: {
                            color: "#fff", //翻页数字颜色
                        }, //翻页数字设置
                        orient: "horizontal",
                        icon: "rect",
                        x: "center",
                        y: "bottom",
                        bottom: "0",
                        itemWidth: 12,
                        itemHeight: 12,
                        textStyle: {
                            //图例文字的样式
                            color: "#fff",
                            fontSize: 8,
                        },
                        align: "left",
                        // data: legendName
                    },
                    series: [
                        {
                            type: "pie",
                            radius: ["45%", "60%"],
                            center: ["50%", "45%"],
                            data: echartData,
                            hoverAnimation: false,
                            itemStyle: {
                                normal: {
                                    borderWidth: 1,
                                },
                            },
                            labelLine: {
                                show: true,
                                length: 5,
                            },
                            label: {
                                normal: {
                                    formatter: "{d}%",
                                    borderWidth: 0,
                                    color: "#fff",
                                    padding: [20, -10, 15, -10],
                                    rich: {
                                        icon: {
                                            fontSize: 12,
                                        },
                                        name: {
                                            fontSize: 14,
                                            padding: [0, 10, 0, 4],
                                            color: "#fff",
                                        },
                                        value: {
                                            fontSize: 12,
                                            color: "#fff",
                                        },
                                    },
                                },
                            },
                        },
                    ],
                });
            });
        },

        // 回款顾问学历分布
        bottomThreeData() {
            let param = {
                year: this.getYear,
                regionId: this.countryId,
                companyId: this.companyId,
                isIncomeAmount: 1,
                ticket: this.urlData,
            };
            GetRegionalCounselorEducation(param).then((res) => {
                var arr = [];
                res.Data.forEach((e) => {
                    const item = {
                        name: e.EducationText,
                        value: e.StaffCount,
                    };
                    arr.push(item);
                });

                let bottomThree = this.$echarts.init(
                    document.getElementById("bottomThree")
                );

                let color = ["#1C82FF", "#8993FF", "#1FFD8A", "#F8D135"];
                let echartData = arr;

                let formatNumber = function (num) {
                    let reg = /(?=(\B)(\d{3})+$)/g;
                    return num.toString().replace(reg, ",");
                };
                bottomThree.setOption({
                    color: color,
                    tooltip: {
                        trigger: "item",
                        formatter: "{b}: {d}%",
                    },
                    grid: {
                        top: "8%",
                        left: "2%",
                        right: "2%",
                        bottom: "8%",
                        containLabel: true,
                    },
                    legend: {
                        type: "scroll",
                        pageIconColor: "#1C82FF",
                        pageTextStyle: {
                            color: "#fff", //翻页数字颜色
                        }, //翻页数字设置
                        orient: "horizontal",
                        icon: "rect",
                        x: "center",
                        y: "bottom",
                        bottom: "2%",
                        itemWidth: 12,
                        itemHeight: 12,
                        textStyle: {
                            //图例文字的样式
                            color: "#fff",
                            fontSize: 8,
                        },
                        align: "left",
                        // data: legendName
                    },
                    series: [
                        {
                            type: "pie",
                            radius: ["45%", "60%"],
                            center: ["50%", "45%"],
                            data: echartData,
                            hoverAnimation: false,
                            itemStyle: {
                                normal: {
                                    borderWidth: 1,
                                },
                            },
                            labelLine: {
                                show: true,
                                length: 5,
                            },
                            label: {
                                normal: {
                                    formatter: "{d}%",
                                    borderWidth: 0,
                                    color: "#fff",
                                    padding: [20, -10, 15, -10],
                                    rich: {
                                        icon: {
                                            fontSize: 12,
                                        },
                                        name: {
                                            fontSize: 14,
                                            padding: [0, 10, 0, 4],
                                            color: "#fff",
                                        },
                                        value: {
                                            fontSize: 12,
                                            color: "#fff",
                                        },
                                    },
                                },
                            },
                        },
                    ],
                });
            });
        },

        // 回款顾问性别分布
        bottomFourData() {
            let param = {
                year: this.getYear,
                regionId: this.countryId,
                companyId: this.companyId,
                isIncomeAmount: 1,
                ticket: this.urlData,
            };
            GetRegionalCounselorGender(param).then((res) => {
                if (res.Data.length > 0) {
                    this.peopleNum = res.Data[0].StaffCount + res.Data[1].StaffCount;
                }
                var arr = [];
                res.Data.forEach((e) => {
                    const item = {
                        name: e.GenderText,
                        value: e.StaffCount,
                    };
                    arr.push(item);
                });

                let bottomFour = this.$echarts.init(
                    document.getElementById("bottomFour")
                );

                let color = ["#8993FF", "#F8D135"];
                let echartData = arr;

                let formatNumber = function (num) {
                    let reg = /(?=(\B)(\d{3})+$)/g;
                    return num.toString().replace(reg, ",");
                };
                bottomFour.setOption({
                    color: color,
                    tooltip: {
                        trigger: "item",
                        formatter: "{b}: {d}%",
                    },
                    legend: {
                        orient: "horizontal",
                        icon: "rect",
                        x: "center",
                        y: "bottom",
                        itemWidth: 12,
                        itemHeight: 12,
                        align: "left",
                        textStyle: {
                            //图例文字的样式
                            color: "#fff",
                            fontSize: 8,
                        },
                        // data: legendName
                    },
                    series: [
                        {
                            type: "pie",
                            radius: ["45%", "60%"],
                            center: ["50%", "45%"],
                            data: echartData,
                            hoverAnimation: false,
                            itemStyle: {
                                normal: {
                                    borderWidth: 1,
                                },
                            },
                            labelLine: {
                                show: true,
                                length: 5,
                            },
                            label: {
                                normal: {
                                    formatter: "{d}%",
                                    borderWidth: 0,
                                    color: "#fff",
                                    padding: [0, -10, 15, -10],
                                    rich: {
                                        icon: {
                                            fontSize: 16,
                                        },
                                        name: {
                                            fontSize: 14,
                                            padding: [0, 10, 0, 4],
                                            color: "#fff",
                                        },
                                        value: {
                                            fontSize: 12,
                                            color: "#fff",
                                        },
                                    },
                                },
                            },
                        },
                    ],
                });
            });
        },

        // 回款顾问婚姻情况
        bottomFiveData() {
            let param = this.params;
            GetRegionalCounselorMarital(param).then((res) => {
                var arr = [];
                res.Data.forEach((e) => {
                    const item = {
                        name: e.MaritalStatusText,
                        value: e.StaffCount,
                    };
                    arr.push(item);
                });

                let bottomFive = this.$echarts.init(
                    document.getElementById("bottomFive")
                );

                let color = ["#1C82FF", "#48E3EC", "#1FFD8A"];
                let echartData = arr;

                let formatNumber = function (num) {
                    let reg = /(?=(\B)(\d{3})+$)/g;
                    return num.toString().replace(reg, ",");
                };
                bottomFive.setOption({
                    color: color,
                    tooltip: {
                        trigger: "item",
                        formatter: "{b}: {d}%",
                    },
                    legend: {
                        orient: "horizontal",
                        icon: "rect",
                        x: "center",
                        y: "bottom",
                        itemWidth: 12,
                        itemHeight: 12,
                        align: "left",
                        textStyle: {
                            //图例文字的样式
                            color: "#fff",
                            fontSize: 8,
                        },
                        // data: legendName
                    },
                    series: [
                        {
                            type: "pie",
                            radius: ["45%", "60%"],
                            center: ["50%", "45%"],
                            data: echartData,
                            hoverAnimation: false,
                            itemStyle: {
                                normal: {
                                    borderWidth: 1,
                                },
                            },
                            labelLine: {
                                show: true,
                                length: 5,
                            },
                            label: {
                                normal: {
                                    formatter: "{d}%",
                                    borderWidth: 0,
                                    color: "#fff",
                                    padding: [0, -10, 15, -10],
                                    rich: {
                                        icon: {
                                            fontSize: 16,
                                        },
                                        name: {
                                            fontSize: 14,
                                            padding: [0, 10, 0, 4],
                                            color: "#fff",
                                        },
                                        value: {
                                            fontSize: 12,
                                            color: "#fff",
                                        },
                                    },
                                },
                            },
                        },
                    ],
                });
            });
        },
        changIconsBlockPosition(str, index) {
            if (str === "enter") {
                if (index === 1) {
                    this.$refs.iconsFir.$el.classList.add("cont-position-act");
                }
                if (index == 2) {
                    this.$refs.iconsSec.$el.classList.add("cont-position-act");
                }
                if (index == 3) {
                    this.$refs.iconsThr.$el.classList.add("cont-position-act");
                }
                if (index == 4) {
                    this.$refs.iconsFou.$el.classList.add("cont-position-act");
                }
            } else {
                this.$refs.iconsFir.$el.classList.remove("cont-position-act");
                this.$refs.iconsSec.$el.classList.remove("cont-position-act");
                this.$refs.iconsThr.$el.classList.remove("cont-position-act");
                this.$refs.iconsFou.$el.classList.remove("cont-position-act");
            }
        },
        changeTextColor(status) {
            this.isChildText = status;
        },
        download(idName, imgName = "chart") {
            exportImg(idName, imgName);
        },
    },

    computed: {
        isTextColor() {
            return this.isChildText ? "#000" : "#fff";
        },
        getYear() {
            return new Date(this.timer).getFullYear() || new Date().getFullYear();
        },
        params() {
            return {
                year: this.getYear,
                regionId: this.countryId,
                companyId: this.companyId,
                ticket: this.urlData,
            };
        },
    },

    created() {
        this.urlData = sessionStorage.getItem("urlData");
    },
};
</script>

<style scoped>
.tongbi-text {
    display: flex;
    align-items: center;
}

.collection {
    width: 100vw;
    height: 100vh;
    display: flex;
}

.container {
    /* overflow: scroll; */
    width: 100vw;
    height: 100vh;
    padding: 19px 32px;
}

>>>.el-input__inner {
    background: none !important;
    border: 1px solid #1ac9ff !important;
    color: #fff;
}

>>>.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
    background-color: #1e4472 !important;
    color: #ffffff;
}

.el-date-editor .el-range-input {
    background: none !important;
}

>>>.el-date-editor .el-range-input {
    background: none !important;
}

>>>.el-popper[x-placement^="bottom"] {
    margin-top: 0 !important;
}

>>>.el-select-dropdown {
    background-color: none !important;
}

>>>.el-select-dropdown__item.selected {
    background: #1c82ff !important;
    color: #fff;
}

>>>.el-picker-panel {
    background: none !important;
    color: #fff;
}

>>>.el-month-table td .cell,
.el-date-editor .el-range-separator {
    color: #fff;
}

.top-select {
    margin-bottom: 15px;
}

.top-cont {
    width: 100%;
    height: 24%;
}

.middle-cont {
    width: 100%;
    height: 28%;
    margin: 0.8em 0;
    display: flex;
    justify-content: space-between;
}

.middle-block {
    width: 24%;
    height: 100%;
}

.bottom-cont {
    width: 100%;
    height: 28%;
}

.echarts1 {
    height: 100%;
    color: #fff;
    display: flex;
    justify-content: space-between;
}

/* 阴影 */

>>>.dv-border-box-7 .dv-border-svg-container>polyline {
    stroke: #1eb0fc;
}

>>>.dv-border-box-7 {
    box-shadow: 0px 0px 10px 0px #7580be inset !important;
}

>>>.dv-border-box-7:hover {
    box-shadow: 0px 0px 10px 0px #ffdf38 inset !important;
}

>>>.dv-border-box-7 .dv-border-svg-container>polyline:nth-child(2),
>>>.dv-border-box-7 .dv-border-svg-container>polyline:nth-child(4) {
    display: none !important;
}

>>>.dv-border-box-7 .dv-bb7-line-width-5 {
    display: none !important;
}

>>>.dv-border-box-7 .dv-bb7-line-width-2 {
    stroke-width: 4;
}

>>>.dv-border-box-7:hover .right-top polygon {
    stroke: #ffdf38;
    fill: #ffdf38;
}

>>>.dv-border-box-7:hover .left-top polygon {
    stroke: #ffdf38;
    fill: #ffdf38;
}

>>>.dv-border-box-7:hover .right-bottom polygon {
    stroke: #ffdf38;
    fill: #ffdf38;
}

>>>.dv-border-box-7:hover .left-bottom polygon {
    stroke: #ffdf38;
    fill: #ffdf38;
}

/* 顶部 */
.echarts-top-num,
.echarts-top-surface {
    width: 48%;
    padding: 16px 8px;
}

.top-icon {
    display: inline-block;
    padding: 5px 92px 5px 12px;
    background: url(../../assets/img/cont-bg-four.png) no-repeat;
    letter-spacing: 1px;
    font-size: 14px;
    min-width: 66px;
    background-size: 100%;
    background-position: center;
    height: 32px;
    line-height: 32px;
}

.width-height {
    width: 96%;
    height: 100%;
}

.div-index {
    height: 14%;
    /* position: absolute; */
    width: 100%;
    z-index: 999;
}

/* 中间 */
.cont-top-bg {
    padding: 4px 52px 4px 12px;
    background: url(../../assets/img/cont-bg-six.png) no-repeat;
    letter-spacing: 1px;
    font-size: 14px;
    min-width: 168px;
    background-size: 100%;
    position: absolute;
    /* text-align: center; */
    background-position: center;
    height: 32px;
    line-height: 32px;
}

.cont-top-bg1 {
    width: 220px;
    display: inline-block;
    padding: 5px 52px 5px 12px;
    background: url(../../assets/img/cont-bg-nten.png) no-repeat;
    letter-spacing: 1px;
    font-size: 16px;
    /* min-width: 172px; */
    background-size: 100%;
    position: absolute;
    /* text-align: center; */
    background-position: center;
    height: 26px;
    line-height: 26px;
}

.cont-bg-event {
    /* width: 180px; */
    display: inline-block;
    padding: 5px 52px 5px 12px;
    background: url(../../assets/img/cont-bg-eight.png) no-repeat;
    letter-spacing: 1px;
    font-size: 14px;
    min-width: 172px;
    background-size: 100%;
    position: absolute;
    /* text-align: center; */
    background-position: center;
    height: 32px;
    line-height: 32px;
}

.cont-moddle {
    padding: 16px 8px;
    color: #fff;
    width: 92%;
    height: 88%;
}

/* 底部 */
.bottom {
    height: 85%;
    color: #fff;
    padding: 10px 8px;
    display: flex;
    justify-content: space-between;
}

.bottom-two {
    width: 25%;
}

.bottom-one,
.bottom-three,
.bottom-four,
.bottom-five,
.bottom-six {
    width: 15%;
}

.middle-right-container {
    display: flex;
    justify-content: space-between;
    height: 87%;
}

.middle-right-left {
    position: relative;
    top: 8%;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

#bottomOne,
#bottomTwo,
#bottomThree,
#bottomFour,
#bottomFive {
    margin-top: 0;
}

.middle-right-right {
    width: 80%;
    height: 100%;
}

.people-img {
    width: 112px;
    /* width: 68%; */
    height: 76px;
    background: url(../../assets/img/people-icon.png) no-repeat;
    background-size: 100%;
    margin-bottom: 15px;
    /* margin-bottom: 2%; */
}

.p-text {
    font-size: 22px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffdf38;
    line-height: 30px;
    letter-spacing: 1px;
    text-align: center;
}

.p-text-bot {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 17px;
    text-align: center;
}

.p-font {
    font-size: 15px;
    padding-left: 8%;
    padding-top: 3%;
}
</style>
<style scoped>
>>>.chartNum {
    margin: 30px 0px;
    display: flex;
    justify-content: center;
}

>>>.box-items {
    width: auto;
    font-family: Digital-7;
    position: relative;
    height: 70px;
    text-align: center;
    list-style: none;
    writing-mode: vertical-lr;
    text-orientation: upright;
    -moz-user-select: none;
    /*火狐*/
    -webkit-user-select: none;
    /*webkit浏览器*/
    -ms-user-select: none;
    /*IE10*/
    -khtml-user-select: none;
    /*早期浏览器*/
    user-select: none;
    /* margin-left: 45px;
  margin-top: 30px; */
    padding: 3% 0px 0px 4%;
}

>>>.mark-item span {
    position: absolute;
    width: 100%;
    bottom: 10px;
    writing-mode: vertical-rl;
    text-orientation: upright;
}

/*滚动数字设置*/
>>>.number-item {
    text-align: center;
    width: 60px;
    height: 72px;
    line-height: 70px;
    float: left;
    /* background: #10213b; */
    box-shadow: 0px 0px 7px 0px #7580be inset;
    list-style: none;
    font-family: Digital-7;
    font-size: 60px;
    color: #b9d2e8;
    margin-right: 3px;
    display: flex;
    justify-content: center;
    margin-right: 10px;
}

>>>.number-item span {
    position: relative;
    display: inline-block;
    margin-right: 18px;
    width: 100%;
    height: 100%;
    writing-mode: vertical-rl;
    text-orientation: revert;
    overflow: hidden;
}

>>>.number-item span i {
    font-style: normal;
    position: absolute;
    font-size: 48px;
    top: 12px;
    left: 50%;
    transform: translate(-50%, 0);
    transition: transform 1s ease-in-out;
    letter-spacing: 10px;
    color: #ffdf38;
}

.number-item:last-child {
    margin-right: 0;
}

.num-dis {
    display: flex;
    align-items: center;
}

.num-right {
    margin-top: 40px;
    margin-left: 25px;
}

.tongbi {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 22px;
    letter-spacing: 1px;
}

.bfbNum {
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 42px;
    letter-spacing: 2px;
}

#china-map {
    width: 1000px;
    height: 1000px;
    margin: auto;
}

#box {
    display: none;
    background-color: goldenrod;
    width: 180px;
    height: 30px;
}

#box-title {
    display: block;
}

.middle-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
}

.cont-position {
    position: relative;
    left: 112px;
    transition: all 0.3s linear;
}

.cont-position-act {
    left: 0px;
}

.icons-block {
    overflow: hidden;
    margin-right: 6px;
    padding: 4px 2px;
    position: absolute;
    right: 8px;
}
</style>
<style scoped>
.number {
    color: #fff;
    margin-left: 16px;
    margin-top: 30px !important;
}

@media (min-width: 1279px) and (max-width: 1365px) {
    .box-items {
        margin-left: 5px !important;
        margin-top: 20px !important;
    }

    .num-right {
        margin-left: 12px !important;
        margin-top: 20px !important;
    }

    .bfbNum {
        font-size: 14px !important;
        line-height: 0 !important;
    }

    .tongbi {
        font-size: 14px !important;
    }

    .icon-svg {
        width: 26px;
        height: 26px;
        display: inline-block;
    }

    .icon-svg svg {
        width: 17px;
        height: 23px;
        position: relative;
        top: 1px;
    }

    .p-p {
        font-size: 16px;
    }

    .cont-moddle {
        padding: 8px !important;
        height: 90% !important;
    }

    .cont-bg-div {
        height: 20%;
    }

    .width-height {
        height: 85% !important;
    }

    .container {
        height: 90vh !important;
        padding: 15px 15px;
    }

    .top-cont {
        height: 26%;
    }

    .middle-cont {
        height: 30%;
    }

    .bottom-cont {
        height: 30%;
    }

    .cont-bg-event {
        width: 115px !important;
        min-width: 115px !important;
        height: 25px !important;
        line-height: 25px !important;
        font-size: 12px !important;
    }

    .cont-top-bg1,
    .cont-top-bg {
        width: 130px !important;
        font-size: 12px !important;
        height: 26px !important;
        line-height: 26px !important;
        min-width: 0 !important;
    }

    #width-height {
        height: 100% !important;
    }

    .top-icon {
        padding: 0 92px 0 12px !important;
    }

    .people-img {
        width: 92px !important;
        height: 56px !important;
        margin-bottom: 0 !important;
    }

    .p-text {
        font-size: 18px;
    }

    .p-font {
        font-size: 14px !important;
    }
}
</style>

<style>
.to__led-number {
    margin-right: 9px;
    font-size: 40px;
    color: #ffdf38;
    width: 50px !important;
    height: 75px !important;
    line-height: 75px !important;
    text-align: center;
    border: 1px solid #1582a3;
    /* background: #10213b; */
    box-shadow: inset 0px 0px 7px 0px #7580be;
    border-radius: 4px;
    display: inline-block;
    vertical-align: middle;
    box-sizing: border-box;
}

.to__led-number--no {
    width: 19px;
    background: none;
    border: none;
    box-shadow: none;
    color: #fff;
}

.icon-svg svg {
    width: 22px;
    height: 38px;
    position: relative;
    top: 5px;
}

@media (min-width: 1400px) {
    #cont-bg-div {
        height: 14%;
    }

    #width-height {
        height: 100%;
    }

    .echarts-h {
        width: 100%;
        height: 95%;
    }

    #height-bg {
        height: 92% !important;
    }
}

@media (min-width: 1279px) and (max-width: 1365px) {
    .number-item {
        width: 35px !important;
        height: 45px !important;
        line-height: 45px !important;
        font-size: 30px !important;
    }

    /* .num-dis {
    align-items: start !important;
  } */
    .number-item span i {
        font-size: 30px !important;
        top: 8px !important;
    }

    #height-bg {
        height: 87% !important;
    }

    .echarts-h {
        width: 100%;
        height: 95%;
    }

    .to__led-number {
        margin-right: 6px;
        font-size: 26px;
        width: 35px !important;
        height: 55px !important;
        line-height: 55px !important;
        text-align: center;
        display: inline-block;
        vertical-align: middle;
        box-sizing: border-box;
    }

    .to__led-number--no {
        width: 7px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/dataChart/collection.vue